export const NEW_MESSAGE = "new_message";
export const INCOMING_CALL = "incoming_call";
export const WAITING_USER = "waiting_user";
export const EXISTING_NEW_MESSAGE = "existing_new_message";
